import React, { useEffect, useRef, useState } from "react";
import axios from 'axios';
import GoogleSignin from "../../assets/images/btn_google_signin_dark_pressed_web.png";
import Logo from "../../assets/images/logo_radioital_negro.png";
import { auth, db } from "../../Firebase";
import { GoogleAuthProvider, signInWithRedirect, signInWithPopup } from "firebase/auth";
import { query, getDocs, collection, where, addDoc} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import Fab from '@mui/material/Fab';
import ChatIcon from '@mui/icons-material/Chat';

const RES_URL = 'https://radioital.com/api/public/api/login/';

function loginSend(m, n){
  axios.get(RES_URL + m + "/" + n, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then(function(res){
      localStorage.setItem('token', res.data.token);
      return false;
    });
}

const Welcome = ({ user, isOpen, onOpen, onClose }) => {
  const [name, setName] = useState(null);
  const [mail, setMail] = useState(null);
  const [token, setToken] = useState(false);
  const expand = isOpen ? "open" : "";
  const provider = new GoogleAuthProvider();
  const signInWithGoogle = async () => {
    try {
      const res = await signInWithPopup(auth, provider);
      const users = res.user;
      user = users;
      axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
      axios.defaults.headers.post['Content-Type'] = 'application/json';
      await axios.get(RES_URL + users.email + "/" + users.displayName, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(function(res){
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('uid', res.data.uid);
          return false;
        });
      const q = query(collection(db, "users"), where("uid", "==", users.uid));
      const docs = await getDocs(q);
      if (docs.docs.length === 0) {
        const rd = await addDoc(collection(db, "users"), {
          uid: users.uid,
          name: users.displayName,
          authProvider: "google",
          email: users.email,
        });
      }
      window.location.reload(true);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  return (
    <>
      <Fab className="btnChat" variant="extended" onClick={!isOpen ? onOpen : onClose}>
          <ChatIcon sx={{ mr: 1 }} />
          {!isOpen ? "ABRIR CHAT" : "CERRAR CHAT" }
      </Fab>
      <div className={`navBox ${expand} chat-box`}>
        <h3>Chat RadioItal.com</h3>
        <img src={Logo} alt="Radioital logo" width={50} height={50} />
        <p className="txt_ini">Conectate a Radioital.com con tu cuenta de Google y comparte con la comunidad tus opiniones en el chat y el foro comunitario.</p>
        <button className="sign-in">
          <img
            onClick={signInWithGoogle}
            src={GoogleSignin}
            alt="sign in with google"
            type="button"
          />
        </button>
      </div>
    </>
  );
};

export default Welcome;